import { FiPackage } from 'react-icons/fi';
import type { NavItem } from '@/app/config/navigation';

/**
 * Catalog module manifest.
 *
 * The module's registration: the routes it answers and the navigation entry it
 * contributes. The build-time allowlist in `src/app/config/navigation.ts` is
 * the registry the shell composes from; this file states the module's own
 * side of it.
 *
 * PERMISSIONS ARE THE API'S
 * --------------------------
 * `catalog.offer.read` is the tenant permission that reads the tenant's own
 * sellable offers. The catalogue READ itself is PUBLIC scope in M66 — its
 * WRITES (`catalog.product.create`, `catalog.product.publish`, …) are
 * PLATFORM-scoped — so the list route declares no read permission and the
 * detail route declares the offer read only for the offers it shows.
 */
export const CATALOG_OFFER_READ_PERMISSION = 'catalog.offer.read';

export const MANIFEST = {
  id: 'catalog',
  routes: [
    { path: '/catalog/products', permission: null },
    { path: '/catalog/products/:productId', permission: null },
    // The AI-ASSISTED setup screen. It creates categories and attribute
    // definitions, and the API authorizes those WRITES by permission
    // (`catalog.category.create`, `catalog.attribute.write`); the screen
    // itself is a console affordance, so it declares no read permission.
    { path: '/catalog/setup', permission: null },
  ],
} as const;

export const NAV_ITEMS: ReadonlyArray<NavItem> = [
  {
    id: 'catalog.products',
    to: '/catalog/products',
    label: 'Products',
    group: 'Catalog',
    order: 30,
    capability: 'retail_basic',
    icon: FiPackage.name,
  },
];
